import React from "react";

import { SpinnerContainerS, SpinnerS } from "./Spinner.style";

const Spinner = () => {
  return (
    <SpinnerContainerS>
      <SpinnerS />
    </SpinnerContainerS>
  );
};

export default Spinner;
